import { render, staticRenderFns } from "./RegisterDocuments.vue?vue&type=template&id=8c05ea38&"
import script from "./RegisterDocuments.vue?vue&type=script&lang=js&"
export * from "./RegisterDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports